import React from 'react';
import SelectFile from './SelectFile';
import FileItem from './FileItem';

class FileList extends React.Component{
    onSelect = (files)=>{
        let me = this;
        let props = this.props;
        let extFiles = props.value || [];
        let totalFiles = extFiles.concat(files);
        let len = totalFiles.length;
        let amountLimit = this.props.file_amount_limit || 5;
        // let fileResult = [];
        // let index = 0;

        // totalFiles.forEach((file)=>{
        //     let fileReader = new FileReader();
        //     fileReader.onload = function(){
        //         index++;
        //         if (fileResult.includes(this.result)) {
        //             Toast.info('该文件已在列表中', 1.5);
        //         }else {
        //             fileResult.push(this.result);
        //             if (index === len) {
        //                 // 长度限制
        //                 totalFiles = totalFiles.slice(0, amountLimit);
        //                 me.setState({
        //                     selectable: len < amountLimit
        //                 });
        //                 let onChange = props.onChange;
        //                 onChange && onChange(totalFiles);
        //             };
        //         }
        //     }
        //     fileReader.readAsDataURL(file);
        // })

        // 长度限制
        totalFiles = totalFiles.slice(0, amountLimit);

        me.setState({
            selectable: len < amountLimit
        });
        let onChange = props.onChange;
        onChange && onChange(totalFiles);
    }
    onDelete = (index)=>{
        let props = this.props;
        let files = props.value || [];

        files.splice(index, 1);

        let onChange = this.props.onChange;
        onChange && onChange(files);
    }
    onUpload = (index, file)=>{
        let props = this.props;
        let files = props.value || [];

        files.splice(index, 1, file);
        
        let onChange = this.props.onChange;
        onChange && onChange(files);
    }
    
    render(){
        let files = this.props.value || [];
        let length = files.length;
        
        let filesEl = (<div className="file-list">
            {files.map((file, index)=>{
                return <FileItem className="list-item" key={file.id} file={file} index={index} delete={()=>{this.onDelete(index)}} upload={this.onUpload}></FileItem>
            })}
        </div>)
        let amountLimit = this.props.file_amount_limit || 5;
        
        let selectable = length < amountLimit;
        return (
            <div className="file-list-wrapper">
                {length ? filesEl : null}
                {selectable && <SelectFile select={this.onSelect} {...this.props}/>}
            </div>
        )
    }
}
export default FileList;


// WEBPACK FOOTER //
// ./src/component/FileAttachment/FileList.js